import { useState, useEffect, useMemo } from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, Label, Input, Spinner,FormGroup } from 'reactstrap';
import { flushSync } from "react-dom";
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import './EffluentDisposal.css';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import ItemCommonTop from '../ItemPopup/ItemCommonTop';
import ItemCommonBottom from '../ItemPopup/ItemCommonBottom';
import ItemFooter from '../ItemPopup/ItemFooter';
import Action from '../Action/Action';
import MapView from '../Map/MapView';
import NonMapView from '../ItemsView/NonMapView';
import MaintenancePlan from '../MaintenancePlan/MaintenancePlan';
import EffluentDisposalItemSpecView from './EffluentDisposalItemSpecView';
import Validate from '../Validate/Validate';
import ToggleSwitch from '../ThreeStateToggle/ToggleSwitch';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import RiskSummary from '../ItemsView/RiskSummary';
import ItemTypeListViewForMap from '../ItemsView/ItemTypeListViewForMap';
import Draggable, { DraggableCore } from 'react-draggable';
import LargeFarmView from '../ItemsView/LargeFarmView';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import ItemBasedAction from '../Action/ItemBasedAction';
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";
function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}


const EffluentDisposal = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage, refreshToken }) => {
    const roleName = localStorage.getItem("roleName");
    const [show_HistoricalActions, setShow_HistoricalActions] = useState(false);
    const [show_SectionComment, setShow_SectionComment] = useState(false);
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [isNextButtonVisible, setIsNextButtonVisible] = useState(false); const { height, width } = useWindowDimensions();
    const [searchParams, setSearchParams] = useSearchParams(); const [toggleSwitch, setToggleSwitch] = useState('map & details'); const [isThisPageCompleted, setIsThisPageCompleted] = useState(false); const [actionsCount, setActionsCount] = useState(0);
    const { state } = useLocation(); const [saving, setSaving] = useState(''); const [itemDeletesaving, setItemDeleteSaving] = useState('');
    const navigate = useNavigate(); const [luDisplay, setLUDisplay] = useState('Irrigated Only'); const [luDisplayDisabled, setLUDisplayDisabled] = useState(false);
    const [farmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId] = useState(localStorage.getItem("loggedInUserId"));
    const [formErrors, setFormErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [effluentDisposal, setEffluentDisposal] = useState({
        outlineList: [], itemList: [], itemTypes: [], uniqueItemTypes: [], Section: 'Effluent Disposal', SectionName: 'Effluent Disposal', itemFieldTypes: [],
        effluentStorageTypeList: [], effluentApplicationMethodList: [], pondSolidsSpreadInList: [], seperatedSolidsStoredTypeList: [],
        seperatedSolidsSpreadInList: [], monthList: [], blockList: [], SectionObj: {}, isWizardCompleted: false,
        outlineCenter: {}, farmCenterTypeModel: {}, outlineItemTypes: [], sectionComment: ''
    });
    const [largeEnterpriseDetails, setLargeEnterpriseDetails] = useState({ isLargeEnterprise: false, LMUList: [], selectedLMUId: 0, isSmallEnterpriseShow: true, filteredLMUList: [],page:'Effluent Disposal' })
    const [typeid, setTypeId] = useState(0);
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false, isLMUPage: false, isCenterReq: false, isFarmCenterEditable: false, showLabel: false,
        isFarmOutlineEditable: false, zoomLevel: 15, polyType: '', itemsEditable: false, highlighteditemId: 0, isHiglighted: false, isClear: false
    });
    const [riskLookupList, setRiskLookupList] = useState({ riskList: [], categoryList: [], enterpriseTypes: [], luenterpriseTypes: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], tempActivitySubGroups: [], LUEnterpriseTypes: [] });
    const [wholeFarmActionPopup, setWholeFarmActionPopup] = useState({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    const [itemPopup, setItemPopup] = useState({ showItemPopup: false, mapitem: [], farmId: farmId, id: 0, itemId: 0, markertype: '', canArchive: true });
    const [itemPopupHeader, setItemPopupHeader] = useState({
        page: 'Effluent Disposal', lmu: '', LMUId: 0, itemTypeName: '', LMUIds: '', itemTypeId: 0, Name: '',
        isDragged: false, Description: '', color: "#21b546", isEdited: false, itemTypeDescription: ''
    });
    const [itemPopupMaptype, setItemPopupMaptype] = useState({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', });

    const [itemPopupBiodiversity, setItemPopupBiodiversity] = useState({ isVisible: false, isItemToBiodiversity: false, biodiversityComment: '' });
    const [itemPopupRisk, setItemPopupRisk] = useState({
        isRisk: 'No', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '',
        showEnterprise: true, category: '', significance: '', riskId: []
    });
    const [itemPopupAchievements, setItemPopupAchievements] = useState({ isAchievementsNotes: false, achievementsComment: '', isExpand: false });

    const [itemDeletePopup, setItemDeletePopup] = useState({ showItemDeletePopup: false, itemId: 0 });
    const [actionPopup, setActionPopup] = useState({ isHavingItemBasedAction: false, showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    const [maintenancePlanPopup, setMaintenancePlanPopup] = useState({ showMaintenancePlanPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    const [itemPopupItemField, setItemPopupItemField] = useState({
        itemTypeId: 0,
        itemFieldTypes: []
    });
    const [itemPopupItemSepcQ, setItemPopupItemSepcQ] = useState({
        IsSprayFromSump: false,
        IsHoldingPond: false,
        IsExportedOffFarm: false,
        IsEffluentSystemOther: false,
        DaysOfEffluentStorage: 0,
        EffluentApplicationMethod: 0,
        IsLessThan12mm: false,
        Is12mmTo24mm: false,
        IsGreaterThan24mm: false,
        IsEffluentPondHaveStirrer: false,
        PondSolidsSpreadIn: 0,
        HowOftenPondSoildsRemoved: '',
        WerePondSoildsRemovedAndSpread: false,
        DoYouSeperateSoildsPriorToEffluentEntering: false,
        SeperatedSolidsStoredType: 0,
        SprayIrrigatorType: '',
        HasEffluentStoragePondDamBeenLeakTested: '',
        LeakTestingDetailOutcome: '',
        SeperatedSolidsSpreadIn: 0,
        IsSeperatedSolidsStoredUnderCover: false,
        pondSolidsSpreadInMonthListSelectedValues: [],
        pondSolidsSpreadInMonthSelectedValues: '',
        pondSolidsBlockListSelectedValues: [],
        pondSolidsBlockSelectedValues: '',
        seperatedSolidsBlockListSelectedValues: [],
        seperatedSolidsBlockSelectedValues: '',
        seperatedSolidsSpreadInMonthListSelectedValues: [],
        seperatedSolidsSpreadInMonthSelectedValues: '', EffluentStorageType:0
    });

    const [toggleItemTypeListState, setToggleItemTypeListState] = useState({ isOpen: false, isIconUp: false });
    const [toggleItemTypeState, setToggleItemTypeState] = useState({ itemTypeId: 0, isOpen: false, isIconUp: false });
    const [toggleItemState, setToggleItemState] = useState({ itemId: 0, isOpen: false, isIconUp: false });
    const [riskSummaryPopup, setRiskSummaryPopup] = useState({ showriskSummary: false });
    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/effluentdisposal/GetEffluentDisposal/', {
                params: {
                    farmId: farmId
                }
            }
            );
            if (response.data.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName == response.data.section.routePath);
                if (section.length > 0) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }
            if (response.data.wizard.isEffluentDisposalSaved) {
                setIsThisPageCompleted(true);
            }
            else {
                setIsThisPageCompleted(false);
            }
            setActionsCount(response.data.actionCount);
            setShow_HistoricalActions(response.data.show_HistoricalActions);
            setShow_SectionComment(response.data.show_SectionComment);
            setEffluentDisposal({
                ...effluentDisposal, outlineList: response.data.outlineList, itemList: response.data.itemList, itemTypes: response.data.itemTypes, uniqueItemTypes: response.data.uniqueItemTypes, itemFieldTypes: response.data.itemFieldList,
                effluentApplicationMethodList: response.data.effluentApplicationMethodList, pondSolidsSpreadInList: response.data.pondSolidsSpreadInList,
                seperatedSolidsStoredTypeList: response.data.seperatedSolidsStoredTypeList, seperatedSolidsSpreadInList: response.data.seperatedSolidsSpreadInList
                , monthList: response.data.monthList, blockList: response.data.blockList, SectionObj: response.data.section, isWizardCompleted: response.data.isFWFPCompleted,
                effluentStorageTypeList: response.data.effluentStorageTypeList, outlineCenter: response.data.outlineCenter, farmCenterTypeModel: response.data.farmCenterTypeModel
                , outlineItemTypes: response.data.outlineItemTypes, sectionComment: response.data.sectionComment
            });
            const content = ContentState.createFromBlockArray(convertFromHTML(response.data.sectionComment == null ? '' : response.data.sectionComment))
            setEditorState(EditorState.createWithContent(content));
            setRiskLookupList({
                ...riskLookupList, riskList: response.data.riskList, enterpriseTypes: response.data.riskModel.enterpriseTypes, luenterpriseTypes: [], contaminants: response.data.riskModel.contaminants, riskDataGroups: response.data.riskModel.riskDataGroups
                , activityGroups: response.data.riskModel.activityGroups, activitySubGroups: [], tempActivitySubGroups: response.data.riskModel.activitySubGroups, LUEnterpriseTypes: response.data.riskModel.luEnterpriseTypeList,
                categoryList: response.data.riskModel.categoryList
            })
            setMapDetails({ ...mapDetails, zoomLevel: response.data.selectedZoomlevel, polyType: '' });
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isLargeEnterprise: response.data.islargeEnterprise, LMUList: response.data.lmuItemList, filteredLMUList: response.data.lmuItemList.filter(x => x.lmuItems[0].isReceivesLiquidEffluent == true) })
            setLoading(false);
            setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: !response.data.isFWFPCompleted, isIconUp: !response.data.isFWFPCompleted })
            if (state != null) {
                const { itemId, actionId, navigateFrom } = state;
                navigate(state.pathname, { replace: true });
                if (navigateFrom == "Actions") {
                    handleNavigateOpenActionPopup(itemId, actionId, response.data);
                }
                else {
                    editMapItemFromNavigation(itemId, response.data, navigateFrom)
                }
            }
            let search = window.location.search;
            let params = new URLSearchParams(search);
            let navigateFrom = params.get('navigateFrom');
            if (navigateFrom == 'Actions') {
                let actionId = params.get('actionId');
                let itemId = params.get('itemId');
                let isWholeFarmAction = params.get('isWholeFarmAction');
                if (searchParams.has('actionId')) {
                    searchParams.delete('actionId');
                    setSearchParams(searchParams);
                }
                if (searchParams.has('itemId')) {
                    searchParams.delete('itemId');
                    setSearchParams(searchParams);
                }
                if (searchParams.has('isWholeFarmAction')) {
                    searchParams.delete('isWholeFarmAction');
                    setSearchParams(searchParams);
                }
                if (searchParams.has('navigateFrom')) {
                    searchParams.delete('navigateFrom');
                    setSearchParams(searchParams);
                }
                if (isWholeFarmAction == 'true') {
                    handleNavigateOpenWholeActionPopup(itemId, actionId, response.data);
                }
                else {
                    handleNavigateOpenActionPopup(itemId, actionId, response.data);
                }
            }
        } catch (err) {
            console.log(err);
        }
    }
    const handleSectionCommentChange = (e) => {
        const { name, value, checked, type } = e.target;
        setEffluentDisposal({ ...effluentDisposal, sectionComment: value })
    }
    const handleNavigateOpenActionPopup = (itemId, actionId, effluentDisposal) => {
        const itemDetails = effluentDisposal.itemList.filter(items => items.itemId == itemId)[0];
        setActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: itemDetails.itemTypeId, itemName: itemDetails.name, actionId: actionId });
    };

    const handleNavigateOpenWholeActionPopup = (itemId, actionId, effluentDisposal) => {
        setWholeFarmActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: effluentDisposal.outlineCenter.itemTypeId, itemName: 'Map Centre', actionId: actionId });
    };

    function refreshPage() {
        setLoading(true);
        setRiskLookupList({ ...riskLookupList, enterpriseTypes: [], luenterpriseTypes: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], tempActivitySubGroups: [], LUEnterpriseTypes: [] });
        setFormErrors({});
        setEffluentDisposal({ ...effluentDisposal, outlineList: [], itemList: [], itemTypes: [], uniqueItemTypes: [] });
        OnPageload();
    }

    function resetValues() {
        setItemPopup({ showItemPopup: false, mapitem: [], farmId: farmId, id: 0, itemId: 0, markertype: '', canArchive: true });
        setItemPopupHeader({ page: 'Effluent Disposal', lmu: '', itemTypeName: '', LMUIds: '', itemTypeId: 0, Name: '', isDragged: false, Description: '', color: "#21b546", itemTypeDescription: '' });
        setItemPopupMaptype({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', });
        setItemPopupBiodiversity({ isVisible: false, isItemToBiodiversity: false, biodiversityComment: '' });
        setItemPopupRisk({
            isRisk: 'No', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', category: '', significance: ''
        });
        setItemPopupAchievements({ isAchievementsNotes: false, achievementsComment: '', isExpand: false });
        setItemDeletePopup({ showItemdeletePopup: false, itemId: 0 });
        setFormErrors({});
        setMapDetails({ ...mapDetails, isClear: true, polyType: '' });
    }

    /* Item select  and Clear*/
    const handleItemClick = (event, typeid, polyType) => {
        setTypeId(typeid);
        setMapDetails({ ...mapDetails, polyType: polyType, isClear: false });
        const itemFieldTypesList = effluentDisposal.itemFieldTypes.filter(fieldType => fieldType.itemTypeId == typeid);
        setItemPopupItemField({ ...itemPopupItemField, itemTypeId: typeid, itemFieldTypes: itemFieldTypesList });
    }

    function handleClearSelection() {
        setTypeId(0);
        setMapDetails({ ...mapDetails, polyType: '', isClear: true });
        setItemPopupItemField({ ...itemPopupItemField, itemTypeId: 0, itemFieldTypes: [] });
        window.location.reload(true);
    }

    const handleLMUChange = (event) => {
        var lus = '';
        let luArr = [];
        if (typeof event === 'object' && event.constructor === Object) {
            lus = event.value.toString();
        }
        else {
            event.forEach(lmu => {
                luArr.push(lmu.value);
            })
            lus = luArr.join(",");
        }

        if (lus == '') {
            setItemPopupRisk({ ...itemPopupRisk, isRisk: 'No', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', category: '', significance: '' });
        }
        else if (lus != '') {
            let selectedLUEnterpriseTypes = [];
            var LUEnterpriseTypes = [];//riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == value);
            lus.split(',').forEach(lmu => {
                if (riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == parseInt(lmu)).length > 0) {
                    LUEnterpriseTypes.push(riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == parseInt(lmu)));
                }
            })
            if (LUEnterpriseTypes.length > 0) {
                let LUEnterpriseTypesArray = [];
                LUEnterpriseTypes.forEach(enterpriseArray => {
                    var array = enterpriseArray[0].enterpriseTypeList.split(',');
                    array.forEach(obj => {
                        if (LUEnterpriseTypesArray.filter(x => x == obj).length == 0) {
                            LUEnterpriseTypesArray.push(obj);
                        }
                    })
                });


                //LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

                selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                    return LUEnterpriseTypesArray.includes(String(el.value))
                });
                if (selectedLUEnterpriseTypes.length == 0) {
                    selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                        return el.label == 'N/A'
                    });
                }
                var displayEnterprise = false;
                if (selectedLUEnterpriseTypes.filter(x => x.label == 'N/A').length > 0) {
                    if (selectedLUEnterpriseTypes.length == 1) {
                        displayEnterprise = false;
                    }
                    else {
                        displayEnterprise = true;
                    }
                }
                else {
                    displayEnterprise = true;
                }
            }
            setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes })
            setItemPopupRisk({ ...itemPopupRisk, enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', showEnterprise: displayEnterprise, category: '', significance: '' });
        }

        setItemPopupHeader({ ...itemPopupHeader, LMUIds: lus });
    }

    /*ItemPopup value change Handle*/
    const handleItemPopupHeaderChange = (event) => {
        const { name, value, checked, type } = event.target;
        if (name == 'Name') {
            if (event.target.value.length > 60) {
                return false;
            }
        }
        setFormErrors({});
        setItemPopupHeader({ ...itemPopupHeader, [name]: type == 'checkbox' ? checked : value });
    }

    function handleItemPopupBiodiversity(event) {
        const { name, value, checked, type } = event.target;
        setItemPopupBiodiversity({ ...itemPopupBiodiversity, [name]: type == 'checkbox' ? checked : value });
    }

    function handleItemPopupRisk(event) {
        const { name, value, checked, type } = event.target;
        if (name == 'isRisk' && value == 'Yes') {
            setFormErrors({});
            const errors = {};
            if (itemPopupHeader.LMUIds == '') {
                errors.luid = "Please select LU";
                setFormErrors(errors);
            }
            else {
                setItemPopupRisk({ ...itemPopupRisk, [name]: type == 'checkbox' ? checked : value });
            }
        }
        else if (name == 'isRisk' && value == 'No') {
            setItemPopupRisk({ ...itemPopupRisk, isRisk: 'No', category: '', significance: '', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', showEnterprise:true });
        }
        else {
            setItemPopupRisk({ ...itemPopupRisk, [name]: type == 'checkbox' ? checked : value });
        }
    }
    const handleMultiSelectEnterpriseChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, enterprises: e });
    }
    const handleMultiSelectRiskChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, riskId: e });
    }
    const handleMultiSelectContaminantChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, contaminants: e });
    }
    const handleMultiSelectCategoryChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, category: e });
    }
    const handleMultiSelectRiskDataGroupChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, riskDataGroups: e });
    }

    const handleMultiSelectActivityGroupChange = (e) => {

        setRiskLookupList({
            ...riskLookupList, activitySubGroups: []
        })

        var selectedActivitySubGroups = [];
        let myArrayFiltered = [];
        if (itemPopupRisk.activitySubGroups != undefined && itemPopupRisk.activitySubGroups.length > 0) {
            selectedActivitySubGroups = itemPopupRisk.activitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
            myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
        }
        else {
            myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
        }
        setRiskLookupList({
            ...riskLookupList, activitySubGroups: myArrayFiltered
        })
        setItemPopupRisk({ ...itemPopupRisk, activityGroups: e, activitySubGroups: selectedActivitySubGroups });
    }

    const handleMultiSelectActivitySubGroupChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, activitySubGroups: e });
    }

    function handleItemPopupAchievements(event) {
        const { name, value, checked, type } = event.target;
        setItemPopupAchievements({ ...itemPopupAchievements, [name]: type == 'checkbox' ? checked : value });
    }

    const handleItemSepcValueChange = (event) => {
        const { name, value, checked, type } = event.target;
        setItemPopupItemSepcQ({ ...itemPopupItemSepcQ, [name]: type == 'checkbox' ? checked : value });
    }

    const handleLMUSelectChange = (event) => {
        const { name, value, checked, type } = event.target;
        setLUDisplay('All');
        setLargeEnterpriseDetails({ ...largeEnterpriseDetails, filteredLMUList: largeEnterpriseDetails.LMUList, [name]: type == 'checkbox' ? checked : value })
        if (value == '0') {
            setLUDisplayDisabled(false);
        }
        else {
            setLUDisplayDisabled(true);
        }
    }

    /*Item Add and Submit*/
    function addMapItem(mapItem, maptype) {
        let path, area = 0.0, perimeter = 0.0, coordinates = '';
        var selectedItemType = effluentDisposal.itemTypes.filter(item => item.id == typeid)[0];
        const ItemTypeName = selectedItemType.name;
        const isBiodiversityReq = selectedItemType.isBiodiversityReq == true ? true : false;
        let lmuId = largeEnterpriseDetails.selectedLMUId;
        const defaultColour = selectedItemType.defaultColour != null && selectedItemType.defaultColour != '' ? selectedItemType.defaultColour : "#21b546";

        /***********LMU Identification*************/
        if (maptype == 'marker') {
            largeEnterpriseDetails.LMUList.map((obj) => {
                const outlineCoordinates = obj.mapCoordinates.split(':');
                const outlinepositions = [];
                outlineCoordinates.filter(coor => coor != "").map((Coordinate) => {
                    const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                    outlinepositions.push(pos);
                })
                const outlinePolygon = new window.google.maps.Polygon({
                    paths: outlinepositions
                });
                const pos = { lat: mapItem.getPosition().lat(), lng: mapItem.getPosition().lng() }

                const inside = window.google.maps.geometry.poly.containsLocation(
                    pos,
                    outlinePolygon
                ) ? true : false;
                if (inside) {
                    lmuId = obj.id;
                }
            });
        }
        /***********LMU Identification*************/

        if (maptype == 'marker') {

            coordinates = mapItem.getPosition().lat().toFixed(6) + ", " + mapItem.getPosition().lng().toFixed(6);
        }
        else if (maptype == 'polygon') {
            path = mapItem.getPath();
            area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            var PolygonCoords = "";
            path.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            coordinates = PolygonCoords;
        }
        else if (maptype == 'polyline') {
            path = mapItem.getPath();
            area = 0;
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            var PolygonCoords = "";
            path.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            coordinates = PolygonCoords;
            if (path.getArray().length <= 1) {
                toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                resetValues();
                return false;
            }
        }
        let selectedLUEnterpriseTypes = [];
        if (lmuId != 0) {
            var LUEnterpriseTypes = riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == lmuId);
            if (LUEnterpriseTypes.length != 0) {
                let LUEnterpriseTypesArray = [];

                LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

                selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                    return LUEnterpriseTypesArray.includes(String(el.value))
                });
                if (selectedLUEnterpriseTypes.length == 0) {
                    selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                        return el.label == 'N/A'
                    });
                }
            }
        }

        setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes })

        setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: mapItem, farmId: farmId, id: 0, itemId: 0, markertype: maptype, canArchive: true });
        setItemPopupMaptype({ ...itemPopupMaptype, markertype: maptype, area: area, perimeter: perimeter, coordinates: coordinates });
        setItemPopupHeader({ ...itemPopupHeader, itemTypeName: ItemTypeName, LMUIds: lmuId.toString(), itemTypeId: typeid, LMUId: lmuId, Name: '', isDragged: false, Description: '', color: defaultColour, itemTypeDescription: selectedItemType.itemDescription });
        setItemPopupBiodiversity({ ...itemPopupBiodiversity, isVisible: isBiodiversityReq });
        setItemPopupAchievements({ ...itemPopupAchievements, isExpand: false });
        setItemPopupItemSepcQ({
            ...itemPopupItemSepcQ, IsSprayFromSump: false, IsHoldingPond: false, IsExportedOffFarm: false, IsEffluentSystemOther: false, DaysOfEffluentStorage: 0, EffluentApplicationMethod: 0,
            IsLessThan12mm: false, Is12mmTo24mm: false, IsGreaterThan24mm: false, IsEffluentPondHaveStirrer: false, PondSolidsSpreadIn: 0, HowOftenPondSoildsRemoved: '', WerePondSoildsRemovedAndSpread: false,
            DoYouSeperateSoildsPriorToEffluentEntering: false, SeperatedSolidsStoredType: 0, SprayIrrigatorType: '', SeperatedSolidsSpreadIn: 0, IsSeperatedSolidsStoredUnderCover: false, pondSolidsSpreadInMonthListSelectedValues: [],
            pondSolidsSpreadInMonthSelectedValues: '', pondSolidsBlockListSelectedValues: [], pondSolidsBlockSelectedValues: '', seperatedSolidsBlockListSelectedValues: [], seperatedSolidsBlockSelectedValues: ''
            , seperatedSolidsSpreadInMonthListSelectedValues: [], seperatedSolidsSpreadInMonthSelectedValues: '', EffluentStorageType: 0
            , HasEffluentStoragePondDamBeenLeakTested: '', LeakTestingDetailOutcome: ''
        });
    }

    const handleItemSubmit = async (event) => {
        setFormErrors({});
        const errors = {};
        setSaving(true);
        let enterprises = '';
        let contaminants = '';
        let riskDataGroups = '';
        let activityGroups = '';
        let activitySubGroups = '';
        let category = '';
        var RiskId = 0;
        var RiskIds = '';
        if (itemPopupRisk.isRisk == "Yes") {
            if (itemPopupRisk.riskId == 0 || itemPopupRisk.riskId == null || itemPopupRisk.riskId == undefined) {
                errors.riskSelection = "This is mandatory!";
            }
            else {
                if (typeof itemPopupRisk.riskId === 'object' && itemPopupRisk.riskId.constructor === Object) {
                    RiskIds = itemPopupRisk.riskId.value;
                }
                else if (Array.isArray(itemPopupRisk.riskId)) {
                    let riskArr = [];
                    itemPopupRisk.riskId.forEach(type => {
                        riskArr.push(type.value);
                    })
                    var riskValue = riskArr.join(",");
                    RiskIds = riskValue;
                }
            }
        }
        if (itemPopupHeader.LMUIds == null || itemPopupHeader.LMUIds == '' || itemPopupHeader.LMUIds == undefined || itemPopupHeader.LMUIds == '0') {
            errors.luid = "This is mandatory!";
        }
        setFormErrors(errors);
        if (Object.keys(errors).length == 0) {
            let form = {
                Id: itemPopup.id,
                MapMarkerType: itemPopup.markertype,
                FarmId: itemPopup.farmId,
                ItemId: itemPopup.itemId,
                Name: itemPopupHeader.Name,
                IsDragged: itemPopupHeader.isDragged,
                Description: itemPopupHeader.Description,
                Colour: itemPopupHeader.color,
                LMUId: itemPopupHeader.LMUId,
                ItemTypeId: itemPopupHeader.itemTypeId,
                Area: itemPopupMaptype.area,
                Length: itemPopupMaptype.perimeter,
                MapCoordinates: itemPopupMaptype.coordinates,
                IsAddsToBioDiversity: itemPopupBiodiversity.isItemToBiodiversity,
                BioDiversityComment: itemPopupBiodiversity.biodiversityComment,
                IsItemHaveAnyRisk: itemPopupRisk.isRisk,
                RiskDescription: itemPopupRisk.riskComment,
                IsAchievementOfNote: itemPopupAchievements.isAchievementsNotes,
                AchievementOfNoteComments: itemPopupAchievements.achievementsComment,
                IsSprayFromSump: itemPopupItemSepcQ.IsSprayFromSump,
                IsHoldingPond: itemPopupItemSepcQ.IsHoldingPond,
                IsExportedOffFarm: itemPopupItemSepcQ.IsExportedOffFarm,
                IsEffluentSystemOther: itemPopupItemSepcQ.IsEffluentSystemOther,
                DaysOfEffluentStorage: itemPopupItemSepcQ.DaysOfEffluentStorage,
                EffluentApplicationMethod: itemPopupItemSepcQ.EffluentApplicationMethod,
                IsLessThan12mm: itemPopupItemSepcQ.IsLessThan12mm,
                Is12mmTo24mm: itemPopupItemSepcQ.Is12mmTo24mm,
                IsGreaterThan24mm: itemPopupItemSepcQ.IsGreaterThan24mm,
                IsEffluentPondHaveStirrer: itemPopupItemSepcQ.IsEffluentPondHaveStirrer,
                PondSolidsSpreadIn: itemPopupItemSepcQ.PondSolidsSpreadIn,
                HowOftenPondSoildsRemoved: itemPopupItemSepcQ.HowOftenPondSoildsRemoved,
                WerePondSoildsRemovedAndSpread: itemPopupItemSepcQ.WerePondSoildsRemovedAndSpread,
                DoYouSeperateSoildsPriorToEffluentEntering: itemPopupItemSepcQ.DoYouSeperateSoildsPriorToEffluentEntering,
                SeperatedSolidsStoredType: itemPopupItemSepcQ.SeperatedSolidsStoredType,
                SprayIrrigatorType: itemPopupItemSepcQ.SprayIrrigatorType,
                HasEffluentStoragePondDamBeenLeakTested: itemPopupItemSepcQ.HasEffluentStoragePondDamBeenLeakTested,
                LeakTestingDetailOutcome: itemPopupItemSepcQ.LeakTestingDetailOutcome,
                SeperatedSolidsSpreadIn: itemPopupItemSepcQ.SeperatedSolidsSpreadIn,
                IsSeperatedSolidsStoredUnderCover: itemPopupItemSepcQ.IsSeperatedSolidsStoredUnderCover,
                PondSolidsSpreadInMonthSelectedValues: itemPopupItemSepcQ.pondSolidsSpreadInMonthSelectedValues,
                PondSolidsBlockSelectedValues: itemPopupItemSepcQ.pondSolidsBlockSelectedValues,
                SeperatedSolidsBlockSelectedValues: itemPopupItemSepcQ.seperatedSolidsBlockSelectedValues,
                SeperatedSolidsSpreadInMonthSelectedValues: itemPopupItemSepcQ.seperatedSolidsSpreadInMonthSelectedValues,
                userId: userId,
                isEdited: itemPopupHeader.isEdited,
                EffluentStorageType: itemPopupItemSepcQ.EffluentStorageType,
                ActivityIds: enterprises,
                ContaminantIds: contaminants,
                RiskDataGroupIds: riskDataGroups,
                ActivityGroupIds: activityGroups,
                ActivitySubGroupIds: activitySubGroups,
                RiskLikelihood: itemPopupRisk.likelihood,
                RiskImpact: itemPopupRisk.impact,
                Category: category,
                Significance: itemPopupRisk.significance,
                LMUIds: itemPopupHeader.LMUIds,
                RiskIds: RiskIds
            }
            if (!Validate(form)) {
                try {
                    const response = await apiPost(
                        '/api/effluentdisposal/UpdateEffluentDisposal/', JSON.stringify(form),
                        {
                            headers: { 'Content-Type': 'application/json' },
                            withCredentials: true
                        });
                    if (response.data != null) {
                        await refreshItemDetails();
                        setSaving(false);
                        toast.success("Item details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                        handleItemPopupClose();
                    }
                } catch (error) {
                    console.error('Error:', error);
                }
            }
            else {
                setSaving(false);
            }
        }
        else {
            setSaving(false);
        }
        refreshToken();
    }

    const refreshItemDetails = async () => {
        const response = await apiGet(
            '/api/effluentdisposal/GetEffluentDisposal/', {
            params: {
                farmId: farmId
            }
        }
        );
        setEffluentDisposal({
            ...effluentDisposal, itemList: response.data.itemList, outlineCenter: response.data.outlineCenter
        });
        setActionsCount(response.data.actionCount);
    }
    function handleItemPopupClose() {
        resetValues();
    }

    const handleMapItemEdited = (itemId, type, strValue) => {
        let name = '';
        let value = '';

        if (type == "polygonBoundsChanged") {
            name = 'mapCoordinates';
            var PolygonCoords = "";
            strValue.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            value = PolygonCoords;
        }
        else if (type == "polylineBoundsChanged") {
            name = 'mapCoordinates';
            var PolygonCoords = "";
            strValue.getArray().map((pointCo) => {
                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            value = PolygonCoords;
        }

        const itemList = effluentDisposal.itemList.map(item =>
            item.itemId === itemId
                ? { ...item, [name]: value, isEdited: true }
                : item
        )
        setEffluentDisposal({ ...effluentDisposal, itemList: itemList });

    }
    /*Item Edit and Submit*/
    const editMapItem = async (mapItem, itemId, isDragged) => {
        const itemDetailsTemp = effluentDisposal.itemList.filter(items => items.itemId == itemId)[0];
        try {
            const response = await apiGet(
                '/api/effluentdisposal/GetEffluentDisposalbyId/', {
                params: {
                    itemId: itemId
                }
            }
            );
            const itemDetails = response.data;
            const ItemTypeName = effluentDisposal.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].name;
            const ItemDescription = effluentDisposal.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].itemDescription;
            let coordinates = itemDetails.mapCoordinates;
            if (isDragged) {
                coordinates = mapItem.latLng.lat().toFixed(6) + ", " + mapItem.latLng.lng().toFixed(6);
            }
            let area = 0.0, perimeter = 0.0;
            if (itemDetailsTemp.isEdited == true) {
                if (itemDetailsTemp.mapMarkerType == "polygon") {
                    coordinates = itemDetailsTemp.mapCoordinates;
                    const Coordinates = itemDetailsTemp.mapCoordinates.split(':');
                    const positions = [];
                    Coordinates.filter(coor => coor != "").map((Coordinate) => {
                        const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                        positions.push(pos);
                    })
                    const tempPolygon = new window.google.maps.Polygon({
                        paths: positions
                    });

                    let path = tempPolygon.getPath();
                    area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
                    perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
                }
                else if (itemDetailsTemp.mapMarkerType == "polyline") {
                    coordinates = itemDetailsTemp.mapCoordinates;
                    const Coordinates = itemDetailsTemp.mapCoordinates.split(':');
                    const positions = [];
                    Coordinates.filter(coor => coor != "").map((Coordinate) => {
                        const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                        positions.push(pos);
                    })

                    const tempPolyline = new window.google.maps.Polyline({
                        paths: positions
                    });

                    let path = tempPolyline.paths;
                    area = itemDetails.area;
                    perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
                    if (path.length <= 1) {
                        toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                        resetValues();
                        return false;
                    }
                }
            }
            else {
                area = itemDetails.area;
                perimeter = itemDetails.length;
            }


            const isBiodiversityReq = effluentDisposal.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].isBiodiversityReq == true ? true : false;
            if (itemDetails != null) {
                setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: mapItem, farmId: farmId, id: itemDetails.id, itemId: itemDetails.itemId, markertype: itemDetails.mapMarkerType });
                setItemPopupMaptype({ ...itemPopupMaptype, markertype: itemDetails.mapMarkerType, area: area, perimeter: perimeter, coordinates: coordinates });
                setItemPopupHeader({
                    ...itemPopupHeader, itemTypeName: ItemTypeName, itemTypeId: itemDetails.itemTypeId, Name: itemDetails.name, LMUId: itemDetails.lmuId == null ? 0 : itemDetails.lmuId, LMUIds: itemDetails.lmuIds == null ? '' : itemDetails.lmuIds,
                    isDragged: isDragged, Description: itemDetails.description, color: itemDetails.colour, isEdited: itemDetailsTemp.isEdited, itemTypeDescription: ItemDescription
                });
                setItemPopupBiodiversity({ ...itemPopupBiodiversity, isVisible: isBiodiversityReq, isItemToBiodiversity: itemDetails.isAddsToBioDiversity, biodiversityComment: itemDetails.bioDiversityComment });
                let enterpriseTypes = []
                if (itemDetails.activityIds != "" && itemDetails.activityIds != null) {
                    let enterpriseTypesArray = [];

                    enterpriseTypesArray = itemDetails.activityIds.split(',');

                    riskLookupList.enterpriseTypes.map(type => {
                        if (enterpriseTypesArray.includes(String(type.value))) {
                            enterpriseTypes.push({
                                value: type.value,
                                label: type.label
                            })
                        }
                    })
                }

                let categoryIds = []
                if (itemDetails.category != "" && itemDetails.category != null) {
                    let categoryArray = [];

                    categoryArray = itemDetails.category.split(',');

                    riskLookupList.categoryList.map(type => {
                        if (categoryArray.includes(String(type.value))) {
                            categoryIds.push({
                                value: type.value,
                                label: type.label
                            })
                        }
                    })
                }

                let ContaminantIds = []
                if (itemDetails.contaminantIds != "" && itemDetails.contaminantIds != null) {
                    let ContaminantIdsArray = [];

                    ContaminantIdsArray = itemDetails.contaminantIds.split(',');

                    riskLookupList.contaminants.map(type => {
                        if (ContaminantIdsArray.includes(String(type.value))) {
                            ContaminantIds.push({
                                value: type.value,
                                label: type.label
                            })
                        }
                    })
                }

                let riskDataGroups = []
                if (itemDetails.riskDataGroupIds != "" && itemDetails.riskDataGroupIds != null) {
                    let RiskDataGroupIdsArray = [];

                    RiskDataGroupIdsArray = itemDetails.riskDataGroupIds.split(',');

                    riskLookupList.riskDataGroups.map(type => {
                        if (RiskDataGroupIdsArray.includes(String(type.value))) {
                            riskDataGroups.push({
                                value: type.value,
                                label: type.label
                            })
                        }
                    })
                }

                let activityGroups = []
                if (itemDetails.activityGroupIds != "" && itemDetails.activityGroupIds != null) {
                    let ActivityGroupIdsArray = [];

                    ActivityGroupIdsArray = itemDetails.activityGroupIds.split(',');

                    riskLookupList.riskDataGroups.map(type => {
                        if (ActivityGroupIdsArray.includes(String(type.value))) {
                            activityGroups.push({
                                value: type.value,
                                label: type.label
                            })
                        }
                    })
                }

                setRiskLookupList({
                    ...riskLookupList, activitySubGroups: []
                });

                let myArrayFiltered = [];
                if (activityGroups != undefined && activityGroups.length > 0) {
                    myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                        return activityGroups.some((f) => {
                            return f.value === el.parentId;
                        });
                    });
                }
                else {
                    myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                        return activityGroups.some((f) => {
                            return f.value === el.parentId;
                        });
                    });
                }

                let activitySubGroups = []
                if (itemDetails.activitySubGroupIds != "" && itemDetails.activitySubGroupIds != null) {
                    let activitySubGroupIdsArray = [];

                    activitySubGroupIdsArray = itemDetails.activitySubGroupIds.split(',');

                    myArrayFiltered.map(type => {
                        if (activitySubGroupIdsArray.includes(String(type.value))) {
                            activitySubGroups.push({
                                value: type.value,
                                label: type.label
                            })
                        }
                    })
                }

                let riskIds = []
                if (itemDetails.riskIds != "" && itemDetails.riskIds != null) {
                    let riskArray = [];

                    riskArray = itemDetails.riskIds.toString().split(',');

                    riskLookupList.riskList.map(type => {
                        if (riskArray.includes(String(type.value))) {
                            riskIds.push({
                                value: type.value,
                                label: type.label
                            })
                        }
                    })
                }

                setItemPopupRisk({
                    isRisk: itemDetails.isItemHaveAnyRisk, riskComment: itemDetails.riskDescription,
                    enterprises: enterpriseTypes, contaminants: ContaminantIds, riskDataGroups: riskDataGroups,
                    activityGroups: activityGroups, activitySubGroups: activitySubGroups, likelihood: itemDetails.riskLikelihood, impact: itemDetails.riskImpact, showEnterprise: true,
                    category: categoryIds, significance: itemDetails.significance, riskId: riskIds
                });

                let selectedLUEnterpriseTypes = [];
                if (itemDetails.lmuId != 0) {
                    var LUEnterpriseTypes = riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == itemDetails.lmuId);
                    if (LUEnterpriseTypes.length != 0) {
                        let LUEnterpriseTypesArray = [];

                        LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

                        selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                            return LUEnterpriseTypesArray.includes(String(el.value))
                        });
                    }
                }

                setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes, activitySubGroups: myArrayFiltered })

                setItemPopupAchievements({ ...itemPopupAchievements, isAchievementsNotes: itemDetails.isAchievementOfNote, achievementsComment: itemDetails.achievementOfNoteComments, isExpand: false });

                const itemFieldTypesList = effluentDisposal.itemFieldTypes.filter(fieldType => fieldType.itemTypeId == itemDetails.itemTypeId);
                setItemPopupItemField({ ...itemPopupItemField, itemTypeId: itemDetails.itemTypeId, itemFieldTypes: itemFieldTypesList });

                setItemPopupItemSepcQ({
                    IsSprayFromSump: itemDetails.isSprayFromSump,
                    IsHoldingPond: itemDetails.isHoldingPond,
                    IsExportedOffFarm: itemDetails.isExportedOffFarm,
                    IsEffluentSystemOther: itemDetails.isEffluentSystemOther,
                    DaysOfEffluentStorage: itemDetails.daysOfEffluentStorage,
                    EffluentApplicationMethod: itemDetails.effluentApplicationMethod,
                    IsLessThan12mm: itemDetails.isLessThan12mm,
                    Is12mmTo24mm: itemDetails.is12mmTo24mm,
                    IsGreaterThan24mm: itemDetails.isGreaterThan24mm,
                    IsEffluentPondHaveStirrer: itemDetails.isEffluentPondHaveStirrer,
                    PondSolidsSpreadIn: itemDetails.pondSolidsSpreadIn,
                    HowOftenPondSoildsRemoved: itemDetails.howOftenPondSoildsRemoved,
                    WerePondSoildsRemovedAndSpread: itemDetails.werePondSoildsRemovedAndSpread,
                    DoYouSeperateSoildsPriorToEffluentEntering: itemDetails.doYouSeperateSoildsPriorToEffluentEntering,
                    SeperatedSolidsStoredType: itemDetails.seperatedSolidsStoredType,
                    SprayIrrigatorType: itemDetails.sprayIrrigatorType,
                    HasEffluentStoragePondDamBeenLeakTested: itemDetails.hasEffluentStoragePondDamBeenLeakTested,
                    LeakTestingDetailOutcome: itemDetails.leakTestingDetailOutcome,
                    SeperatedSolidsSpreadIn: itemDetails.seperatedSolidsSpreadIn,
                    IsSeperatedSolidsStoredUnderCover: itemDetails.isSeperatedSolidsStoredUnderCover,
                    pondSolidsSpreadInMonthListSelectedValues: itemDetails.pondSolidsSpreadInMonthListSelectedValues,
                    pondSolidsSpreadInMonthSelectedValues: itemDetails.pondSolidsSpreadInMonthSelectedValues,
                    pondSolidsBlockListSelectedValues: itemDetails.pondSolidsBlockListSelectedValues,
                    pondSolidsBlockSelectedValues: itemDetails.pondSolidsBlockSelectedValues,
                    seperatedSolidsBlockListSelectedValues: itemDetails.seperatedSolidsBlockListSelectedValues,
                    seperatedSolidsBlockSelectedValues: itemDetails.seperatedSolidsBlockSelectedValues,
                    seperatedSolidsSpreadInMonthListSelectedValues: itemDetails.seperatedSolidsSpreadInMonthListSelectedValues,
                    seperatedSolidsSpreadInMonthSelectedValues: itemDetails.seperatedSolidsSpreadInMonthSelectedValues,
                    EffluentStorageType: itemDetails.effluentStorageType,
                });
            }

        } catch (err) {
            console.log(err);
        }


    }

    const editMapItemFromNavigation = async(itemId, effluentDisposal, navigateFrom) => {
        const itemDetailsTemp = effluentDisposal.itemList.filter(items => items.itemId == itemId)[0];
        try {
            const response = await apiGet(
                '/api/effluentdisposal/GetEffluentDisposalbyId/', {
                params: {
                    itemId: itemId
                }
            }
            );
            const itemDetails = response.data;
            const ItemTypeName = effluentDisposal.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].name;
            const ItemDescription = effluentDisposal.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].itemDescription;
            let coordinates = itemDetails.mapCoordinates;
            let area = 0.0, perimeter = 0.0;
            if (itemDetailsTemp.isEdited == true) {
                if (itemDetailsTemp.mapMarkerType == "polygon") {
                    coordinates = itemDetailsTemp.mapCoordinates;
                    const Coordinates = itemDetailsTemp.mapCoordinates.split(':');
                    const positions = [];
                    Coordinates.filter(coor => coor != "").map((Coordinate) => {
                        const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                        positions.push(pos);
                    })
                    const tempPolygon = new window.google.maps.Polygon({
                        paths: positions
                    });

                    let path = tempPolygon.getPath();
                    area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
                    perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
                }
                else if (itemDetailsTemp.mapMarkerType == "polyline") {
                    coordinates = itemDetailsTemp.mapCoordinates;
                    const Coordinates = itemDetailsTemp.mapCoordinates.split(':');
                    const positions = [];
                    Coordinates.filter(coor => coor != "").map((Coordinate) => {
                        const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                        positions.push(pos);
                    })

                    const tempPolyline = new window.google.maps.Polyline({
                        paths: positions
                    });

                    let path = tempPolyline.paths;
                    area = itemDetails.area;
                    perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
                    if (path.length <= 1) {
                        toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                        resetValues();
                        return false;
                    }
                }
            }
            else {
                area = itemDetails.area;
                perimeter = itemDetails.length;
            }


            const isBiodiversityReq = effluentDisposal.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].isBiodiversityReq == true ? true : false;
            if (itemDetails != null) {
                setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: [], farmId: farmId, id: itemDetails.id, itemId: itemDetails.itemId, markertype: itemDetails.mapMarkerType });
                setItemPopupMaptype({ ...itemPopupMaptype, markertype: itemDetails.mapMarkerType, area: area, perimeter: perimeter, coordinates: coordinates });
                setItemPopupHeader({
                    ...itemPopupHeader, itemTypeName: ItemTypeName, itemTypeId: itemDetails.itemTypeId, Name: itemDetails.name, LMUId: itemDetails.lmuId == null ? 0 : itemDetails.lmuId, LMUIds: itemDetails.lmuIds == null ? '' : itemDetails.lmuIds,
                    Description: itemDetails.description, color: itemDetails.colour, isEdited: itemDetailsTemp.isEdited, itemTypeDescription: ItemDescription
                });
                setItemPopupBiodiversity({ ...itemPopupBiodiversity, isVisible: isBiodiversityReq, isItemToBiodiversity: itemDetails.isAddsToBioDiversity, biodiversityComment: itemDetails.bioDiversityComment });
                let enterpriseTypes = []
                if (itemDetails.activityIds != "" && itemDetails.activityIds != null) {
                    let enterpriseTypesArray = [];

                    enterpriseTypesArray = itemDetails.activityIds.split(',');

                    riskLookupList.enterpriseTypes.map(type => {
                        if (enterpriseTypesArray.includes(String(type.value))) {
                            enterpriseTypes.push({
                                value: type.value,
                                label: type.label
                            })
                        }
                    })
                }

                let categoryIds = []
                if (itemDetails.category != "" && itemDetails.category != null) {
                    let categoryArray = [];

                    categoryArray = itemDetails.category.split(',');

                    riskLookupList.categoryList.map(type => {
                        if (categoryArray.includes(String(type.value))) {
                            categoryIds.push({
                                value: type.value,
                                label: type.label
                            })
                        }
                    })
                }

                let ContaminantIds = []
                if (itemDetails.contaminantIds != "" && itemDetails.contaminantIds != null) {
                    let ContaminantIdsArray = [];

                    ContaminantIdsArray = itemDetails.contaminantIds.split(',');

                    riskLookupList.contaminants.map(type => {
                        if (ContaminantIdsArray.includes(String(type.value))) {
                            ContaminantIds.push({
                                value: type.value,
                                label: type.label
                            })
                        }
                    })
                }

                let riskDataGroups = []
                if (itemDetails.riskDataGroupIds != "" && itemDetails.riskDataGroupIds != null) {
                    let RiskDataGroupIdsArray = [];

                    RiskDataGroupIdsArray = itemDetails.riskDataGroupIds.split(',');

                    riskLookupList.riskDataGroups.map(type => {
                        if (RiskDataGroupIdsArray.includes(String(type.value))) {
                            riskDataGroups.push({
                                value: type.value,
                                label: type.label
                            })
                        }
                    })
                }

                let activityGroups = []
                if (itemDetails.activityGroupIds != "" && itemDetails.activityGroupIds != null) {
                    let ActivityGroupIdsArray = [];

                    ActivityGroupIdsArray = itemDetails.activityGroupIds.split(',');

                    riskLookupList.riskDataGroups.map(type => {
                        if (ActivityGroupIdsArray.includes(String(type.value))) {
                            activityGroups.push({
                                value: type.value,
                                label: type.label
                            })
                        }
                    })
                }

                setRiskLookupList({
                    ...riskLookupList, activitySubGroups: []
                });

                let myArrayFiltered = [];
                if (activityGroups != undefined && activityGroups.length > 0) {
                    myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                        return activityGroups.some((f) => {
                            return f.value === el.parentId;
                        });
                    });
                }
                else {
                    myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                        return activityGroups.some((f) => {
                            return f.value === el.parentId;
                        });
                    });
                }

                let activitySubGroups = []
                if (itemDetails.activitySubGroupIds != "" && itemDetails.activitySubGroupIds != null) {
                    let activitySubGroupIdsArray = [];

                    activitySubGroupIdsArray = itemDetails.activitySubGroupIds.split(',');

                    myArrayFiltered.map(type => {
                        if (activitySubGroupIdsArray.includes(String(type.value))) {
                            activitySubGroups.push({
                                value: type.value,
                                label: type.label
                            })
                        }
                    })
                }

                let riskIds = []
                if (itemDetails.riskIds != "" && itemDetails.riskIds != null) {
                    let riskArray = [];

                    riskArray = itemDetails.riskIds.toString().split(',');

                    riskLookupList.riskList.map(type => {
                        if (riskArray.includes(String(type.value))) {
                            riskIds.push({
                                value: type.value,
                                label: type.label
                            })
                        }
                    })
                }

                setItemPopupRisk({
                    isRisk: itemDetails.isItemHaveAnyRisk, riskComment: itemDetails.riskDescription,
                    enterprises: enterpriseTypes, contaminants: ContaminantIds, riskDataGroups: riskDataGroups,
                    activityGroups: activityGroups, activitySubGroups: activitySubGroups, likelihood: itemDetails.riskLikelihood, impact: itemDetails.riskImpact, showEnterprise: true,
                    category: categoryIds, significance: itemDetails.significance, riskId: riskIds
                });

                let selectedLUEnterpriseTypes = [];
                if (itemDetails.lmuId != 0) {
                    var LUEnterpriseTypes = riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == itemDetails.lmuId);
                    if (LUEnterpriseTypes.length != 0) {
                        let LUEnterpriseTypesArray = [];

                        LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

                        selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                            return LUEnterpriseTypesArray.includes(String(el.value))
                        });
                    }
                }

                setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes, activitySubGroups: myArrayFiltered })
 
                let isExpand = false;
                if (navigateFrom == "Achievements")
                    isExpand = true
                setItemPopupAchievements({ ...itemPopupAchievements, isAchievementsNotes: itemDetails.isAchievementOfNote, achievementsComment: itemDetails.achievementOfNoteComments, isExpand: isExpand });
                const itemFieldTypesList = effluentDisposal.itemFieldList.filter(fieldType => fieldType.itemTypeId == itemDetails.itemTypeId);
                setItemPopupItemField({ ...itemPopupItemField, itemTypeId: itemDetails.itemTypeId, itemFieldTypes: itemFieldTypesList });

                setItemPopupItemSepcQ({
                    IsSprayFromSump: itemDetails.isSprayFromSump,
                    IsHoldingPond: itemDetails.isHoldingPond,
                    IsExportedOffFarm: itemDetails.isExportedOffFarm,
                    IsEffluentSystemOther: itemDetails.isEffluentSystemOther,
                    DaysOfEffluentStorage: itemDetails.daysOfEffluentStorage,
                    EffluentApplicationMethod: itemDetails.effluentApplicationMethod,
                    IsLessThan12mm: itemDetails.isLessThan12mm,
                    Is12mmTo24mm: itemDetails.is12mmTo24mm,
                    IsGreaterThan24mm: itemDetails.isGreaterThan24mm,
                    IsEffluentPondHaveStirrer: itemDetails.isEffluentPondHaveStirrer,
                    PondSolidsSpreadIn: itemDetails.pondSolidsSpreadIn,
                    HowOftenPondSoildsRemoved: itemDetails.howOftenPondSoildsRemoved,
                    WerePondSoildsRemovedAndSpread: itemDetails.werePondSoildsRemovedAndSpread,
                    DoYouSeperateSoildsPriorToEffluentEntering: itemDetails.doYouSeperateSoildsPriorToEffluentEntering,
                    SeperatedSolidsStoredType: itemDetails.seperatedSolidsStoredType,
                    SprayIrrigatorType: itemDetails.sprayIrrigatorType,
                    HasEffluentStoragePondDamBeenLeakTested: itemDetails.hasEffluentStoragePondDamBeenLeakTested,
                    LeakTestingDetailOutcome: itemDetails.leakTestingDetailOutcome,
                    SeperatedSolidsSpreadIn: itemDetails.seperatedSolidsSpreadIn,
                    IsSeperatedSolidsStoredUnderCover: itemDetails.isSeperatedSolidsStoredUnderCover,
                    pondSolidsSpreadInMonthListSelectedValues: itemDetails.pondSolidsSpreadInMonthListSelectedValues,
                    pondSolidsSpreadInMonthSelectedValues: itemDetails.pondSolidsSpreadInMonthSelectedValues,
                    pondSolidsBlockListSelectedValues: itemDetails.pondSolidsBlockListSelectedValues,
                    pondSolidsBlockSelectedValues: itemDetails.pondSolidsBlockSelectedValues,
                    seperatedSolidsBlockListSelectedValues: itemDetails.seperatedSolidsBlockListSelectedValues,
                    seperatedSolidsBlockSelectedValues: itemDetails.seperatedSolidsBlockSelectedValues,
                    seperatedSolidsSpreadInMonthListSelectedValues: itemDetails.seperatedSolidsSpreadInMonthListSelectedValues,
                    seperatedSolidsSpreadInMonthSelectedValues: itemDetails.seperatedSolidsSpreadInMonthSelectedValues,
                    EffluentStorageType: itemDetails.effluentStorageType,
                });
            }

        } catch (err) {
            console.log(err);
        }


    }

    function handleItemEditPopup(itemId) {
        editMapItem([], itemId, false)
    }

    const handleOpenWholeActionPopup = (itemId, actionId) => {
        setWholeFarmActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: effluentDisposal.outlineCenter.itemTypeId, itemName: 'NA', actionId: actionId });
    };

    const handleWholeActionClose = () => {
        setWholeFarmActionPopup({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    /*Item Delete*/
    function handleItemDeletePopup(itemId) {
        setItemDeletePopup({ showItemDeletePopup: true, itemId: itemId });
    }

    function handleItemDeletePopupClose() {
        setItemDeletePopup({ showItemDeletePopup: false, itemId: 0 });
    }

    const deleteItem = async (event) => {
        setItemDeleteSaving(true);
        const itemid = itemDeletePopup.itemId;
        try {
            const response = await apiGet(
                '/api/effluentdisposal/DeleteItem/', {
                params: {
                    itemId: itemid, userId: userId
                }
            }
            );
            if (response.data != null) {
                await refreshItemDetails();
                setItemDeleteSaving(false);
                handleItemDeletePopupClose();
                handleItemPopupClose();
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    /*Item- Action Popup handle*/
    function handleOpenActionPopup(itemId, actionId) {
        const itemDetails = effluentDisposal.itemList.filter(items => items.itemId == itemId)[0];
        setActionPopup({ isHavingItemBasedAction: itemDetails.isHavingItemBasedAction, showActionPopup: true, itemId: itemId, itemTypeId: itemDetails.itemTypeId, itemName: itemDetails.name, actionId: actionId });
    };

    const handleActionClose = async () => {
        setActionPopup({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    /*Item- MaintenancePlan Popup handle*/
    function handleOpenMaintenancePlanPopup(itemId) {
        const itemDetails = effluentDisposal.itemList.filter(items => items.itemId == itemId)[0];
        setMaintenancePlanPopup({ ...maintenancePlanPopup, showMaintenancePlanPopup: true, itemId: itemId, itemName: itemDetails.name, itemTypeId: itemDetails.itemTypeId, actionId: 0 });
    }

    function handleMaintenancePlanClose() {
        setMaintenancePlanPopup({ ...maintenancePlanPopup, showMaintenancePlanPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    /*handle Toggle for nonMap View*/
    const handleItemTypeListTogole = (isOpen, isIconUp) => {
        setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: isOpen, isIconUp: isIconUp })
    }

    const handleItemTypeTogole = (itemTypeId, isOpen, isIconUp,) => {
        setToggleItemTypeState({ ...toggleItemTypeState, itemTypeId: itemTypeId, isOpen: isOpen, isIconUp: isIconUp })
    }

    const handleItemTogole = (itemId, isOpen, isIconUp) => {
        setToggleItemState({ ...toggleItemState, itemId: itemId, isOpen: isOpen, isIconUp: isIconUp })
    }

    /*handle Item highlight*/
    const handleItemHighlight = (itemId) => {
        setMapDetails({ ...mapDetails, highlighteditemId: itemId })
    }

    const handleRiskSummaryClose = () => {
        setRiskSummaryPopup({ ...riskSummaryPopup, showriskSummary: false })
        window.location.reload(true);
    }

    const handleRiskSummaryOpen = () => {
        setRiskSummaryPopup({ ...riskSummaryPopup, showriskSummary: true })
    }

    /*Avoid unwanted page refresh*/
    const mapView = useMemo(() => {
        return (
            <MapView width={toggleSwitch == 'map' ? '80vw' : '50vw'}
                height={toggleSwitch == 'map' ? '80vw' : '50vw'}
                itemModel={effluentDisposal}
                mapDetails={mapDetails}
                addMapItem={addMapItem}
                largeEnterpriseDetails={largeEnterpriseDetails}
                editMapItem={editMapItem}
                handleMapItemEdited={handleMapItemEdited}
            ></MapView>
        )
    }, [effluentDisposal, mapDetails, largeEnterpriseDetails, toggleSwitch])

    const itemTypeListView = useMemo(() => {

        return (
            <ItemTypeListViewForMap isWizardCompleted={effluentDisposal.isWizardCompleted} Section={effluentDisposal.Section}
                itemTypesList={effluentDisposal.itemTypes}
                toggleItemTypeListState={toggleItemTypeListState}
                handleClearSelection={handleClearSelection}
                handleItemClick={handleItemClick}
                handleItemTypeListTogole={handleItemTypeListTogole}
            >
            </ItemTypeListViewForMap>
        )
    }, [effluentDisposal, largeEnterpriseDetails, effluentDisposal.SectionObj, toggleItemTypeListState, toggleItemTypeState, toggleItemState, effluentDisposal.outlineCenter])

    const nonMapView = useMemo(() => {
        return (
            <NonMapView show_HistoricalActions={show_HistoricalActions} itemModel={effluentDisposal} handleSectionCommentChange={handleSectionCommentChange}
                toggleItemTypeListState={toggleItemTypeListState}
                toggleItemTypeState={toggleItemTypeState}
                toggleItemState={toggleItemState}
                handleClearSelection={handleClearSelection}
                handleItemClick={handleItemClick}
                handleItemEditPopup={handleItemEditPopup}
                handleItemDeletePopup={handleItemDeletePopup}
                handleOpenActionPopup={handleOpenActionPopup}
                sectionObj={effluentDisposal.SectionObj}
                largeEnterpriseDetails={largeEnterpriseDetails}
                handleLMUSelectChange={handleLMUSelectChange}
                handleItemTypeListTogole={handleItemTypeListTogole}
                handleItemTypeTogole={handleItemTypeTogole}
                handleItemTogole={handleItemTogole} handleOpenWholeActionPopup={handleOpenWholeActionPopup}
                handleItemHighlight={handleItemHighlight} outlineCenter={effluentDisposal.outlineCenter}
            ></NonMapView>
        )
    }, [effluentDisposal, largeEnterpriseDetails, effluentDisposal.SectionObj, toggleItemTypeListState, toggleItemTypeState, toggleItemState, effluentDisposal.outlineCenter])

    const toggleSwitchChange = (e) => {
        setToggleSwitch(e)
        if (e == 'map') {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'none';
            document.getElementById('itemTypeListView').style.height = '70vh';
        }
        else if (e == 'details') {
            document.getElementById('mapView').style.display = 'none';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
        else {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
    }

    const [checkActionPopup, setCheckActionPopup] = useState({ showPopup: false, section: '', method: '' });
    const handleCheckActionPopupClose = () => {
        setCheckActionPopup({ showPopup: false, section: '', method: '' });
    }
    const handleCheckCalculatorDataPopupConfirm = () => {
        if (checkActionPopup.method == 'handleWizardChanged') {
            handleWizardChanged(checkActionPopup.section);
        }
        else if (checkActionPopup.method == 'handleMoveToNextPage') {
            handleMoveToNextPage(checkActionPopup.section);
        }
        else if (checkActionPopup.method == 'handleWizardChangedBack') {
            handleWizardChangedBack(checkActionPopup.section);
        }
    }
    const checkAction = async (section, method) => {
        if (!isThisPageCompleted && actionsCount == 0) {
            setCheckActionPopup({ showPopup: true, section: section, method: method });
        }
        else {
            await SaveSectionComment();
            if (method == 'handleWizardChanged') {
                handleWizardChanged(section);
            }
            else if (method == 'handleMoveToNextPage') {
                handleMoveToNextPage(section);
            }
            else if (method == 'handleWizardChangedBack') {
                handleWizardChangedBack(section);
            }
        }
    }

    const handlePageChange = async (section, method) => {
        await SaveSectionComment();
        if (method == 'handleWizardChanged') {
            handleWizardChanged(section);
        }
        else if (method == 'handleMoveToNextPage') {
            handleMoveToNextPage(section);
        }
        else if (method == 'handleWizardChangedBack') {
            handleWizardChangedBack(section);
        }
    }
    const [savingSectionComment, setSavingSectionComment] = useState('');
    const saveSectionComment = async () => {
        setSavingSectionComment(true);
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await apiPost(
                '/api/effluentdisposal/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response) {
                setSavingSectionComment(false);
            }
        } catch (err) {
            console.log(err);
            setSavingSectionComment(false);
        }
    }
    const SaveSectionComment = async () => {
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await apiPost(
                '/api/effluentdisposal/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
        } catch (err) {
            console.log(err);
        }
    }

    function handleLUDisplayChange(event) {
        const { value } = event.target;
        setLUDisplay(value);
        if (value == 'None') {
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, filteredLMUList: [] })
        }
        else if (value == 'Irrigated Only') {
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, filteredLMUList: largeEnterpriseDetails.LMUList.filter(x => x.lmuItems[0].isReceivesLiquidEffluent == true) })
        }
        else if (value == 'All') {
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, filteredLMUList: largeEnterpriseDetails.LMUList })
        }
    }

    const handleEditItemClick = (e) => {
        if (e.target.checked) {
            toast.error("ALERT: when editing a shape remember to click inside the shape when finished, or when editing a line double click on the line, to save any changes.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
        setMapDetails({ ...mapDetails, isFarmCenterEditable: !mapDetails.itemsEditable, isFarmOutlineEditable: !mapDetails.itemsEditable, itemsEditable: !mapDetails.itemsEditable })
    }

    return (
        <div>
            <Modal isOpen={checkActionPopup.showPopup}>
                <ModalHeader toggle={handleCheckActionPopupClose} >Confirm</ModalHeader>
                <ModalBody>
                    You have not created any actions on this page. Are you sure you wish to continue?
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleCheckCalculatorDataPopupConfirm} color="primary">
                        Yes
                    </Button>{' '}
                    <Button color="danger" onClick={handleCheckActionPopupClose}>No</Button>
                </ModalFooter>
            </Modal>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{effluentDisposal.SectionName}</h3></Col>
                <Col>
                    {effluentDisposal.isWizardCompleted != true && !loading &&
                        <>
                        {(roleName == 'SWNZ Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                            <>
                            <Button className="float-end btn-next-page" onClick={(section) => checkAction(effluentDisposal.Section, 'handleWizardChanged')}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        {roleName != 'SWNZ Admin' && saveRightsForNonItemFieldsAndTables == 'false' && isNextButtonVisible &&
                            <>
                            <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(effluentDisposal.Section, 'handleMoveToNextPage')}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(effluentDisposal.Section, 'handleWizardChangedBack')}>Back <FaChevronLeft /> </Button>
                        </>
                    }
                </Col>
                
            </Row>
            <br/>
            {loading ? <SpinnerContainer /> :
                <div>
                    <Row style={{ marginTop: '10px' }}>
                        <Col id='mapView'>
                            <Row className="map-layer">
                                <Col>
                                    <Row>
                                        <Col sm="3"> {toggleSwitch == 'map & details' &&
                                            <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('map')}>Full Map&nbsp;&nbsp;
                                                <img src="/images/button-details_expand.png" className="card_icon" ></img>
                                            </Button>
                                        }
                                            {toggleSwitch == 'map' &&
                                                <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Map&nbsp;&nbsp;
                                                    <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                                </Button>
                                            }
                                        </Col>
                                        <Col sm="1"></Col>
                                        <Col sm="8">
                                            <div className="map-item-edit-div">
                                                <Label className="map-checkbox-label">Edit Item</Label>
                                                <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.itemsEditable} onChange={(e) => handleEditItemClick(e)} name="isItemEdit" id="isItemEdit" />&nbsp;&nbsp;
                                                <Label className="map-checkbox-label">Show Label</Label>
                                                <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.showLabel} onChange={(e) => setMapDetails({ ...mapDetails, showLabel: !mapDetails.showLabel })} name="showLabel" id="showLabel" />&nbsp;&nbsp;
                                            </div>
                                        </Col>
                                    </Row>
                                    {mapView}
                                </Col>
                            </Row>
                        </Col>
                        <Col id="itemTypeListView" style={{ display: toggleSwitch == 'map' ? 'block' : 'none', height: "70vh", overflowY: "scroll", width: "20vw" }}>
                            <Label className="">LU Display</Label>&nbsp;&nbsp;&nbsp;&nbsp;
                            <select className="form-select" value={luDisplay} onChange={handleLUDisplayChange}>
                                <option value="None">None</option>
                                <option value="Irrigated Only">Effluent Only</option>
                                <option value="All">All</option>
                            </select>
                            <br />
                            {itemTypeListView}
                            <br />
                        </Col>
                        <Col id='nonMapView' style={{ width: "50vw", display: toggleSwitch == 'map' ? 'none' : 'block', marginTop: "-25px" }}>
                            <Row>
                                <Col style={{ borderBottom: "1px solid #41533d" }}>
                                    {toggleSwitch == 'map & details' &&
                                        <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#41533d" }} className="btn btnExpandContract" onClick={(e) => toggleSwitchChange('details')}>Full Details&nbsp;&nbsp;
                                            <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                        </Button>
                                    }
                                    {toggleSwitch == 'details' &&
                                        <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#41533d" }} className="btn btnExpandContract" onClick={(e) => toggleSwitchChange('map & details')}>Small Details&nbsp;&nbsp;
                                            <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                        </Button>
                                    }
                                    {
                                        !loading && <Button style={{ marginLeft: "0.5vw", backgroundColor: "#41533d" }} onClick={() => handleRiskSummaryOpen()} className="btn btn-risk-summaryv1">View Risk and Action Summary</Button>
                                    }
                                </Col>
                            </Row>
                            {show_SectionComment &&
                                <>
                                <Row style={{ marginTop: "0.5vh" }}>
                                    <Col sm="12">
                                        <FormGroup>
                                            <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "16px" }}><b>Section Comment</b> <span className="text-lowercase">(add any information around the features, actions, or risks, that have been considered on this page)</span></Label>
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorState}
                                                onEditorStateChange={setEditorState}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>

                                    </Col>
                                    <Col sm="12">
                                        {savingSectionComment ?
                                            <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" disabled>
                                                <Row>
                                                    <Col sm="8">
                                                        <span>
                                                            {' '}Saving
                                                        </span>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Spinner size="sm">
                                                            Saving...
                                                        </Spinner>
                                                    </Col>
                                                </Row>
                                            </Button>
                                            :
                                            <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" size="sm">
                                                Save
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                                <br />
                                </>    
                            }
                            
                            <LargeFarmView largeEnterpriseDetails={largeEnterpriseDetails} handleLMUSelectChange={handleLMUSelectChange}></LargeFarmView>
                            <Label className="">LU Display</Label>&nbsp;&nbsp;&nbsp;&nbsp;
                            <select className="form-select1" value={luDisplay} onChange={handleLUDisplayChange} disabled={luDisplayDisabled}>
                                <option value="None">None</option>
                                <option value="Irrigated Only">Effluent Only</option>
                                <option value="All">All</option>
                            </select>
                            {nonMapView}
                        </Col>
                    </Row>
                </div>
            }
            <Modal size="lg" isOpen={itemPopup.showItemPopup} backdrop={false} className="itemPopup">
                <Form>
                    <ModalHeader toggle={handleItemPopupClose} >Add/Edit Item</ModalHeader>
                    <ModalBody>
                        <ItemCommonTop setFormErrors={setFormErrors} Section={effluentDisposal.Section} handleLMUChange={handleLMUChange} itemPopupHeader={itemPopupHeader} itemPopupMaptype={itemPopupMaptype} itemPopupBiodiversity={itemPopupBiodiversity} itemPopupRisk={itemPopupRisk}
                            largeEnterpriseDetails={largeEnterpriseDetails} formErrors={formErrors} riskLookupList={riskLookupList}
                            handleItemPopupHeaderChange={handleItemPopupHeaderChange} handleMultiSelectRiskChange={handleMultiSelectRiskChange}
                            handleItemPopupBiodiversity={handleItemPopupBiodiversity}
                            handleItemPopupRisk={handleItemPopupRisk} setRiskLookupList={setRiskLookupList} setItemPopupRisk={setItemPopupRisk}
                            handleMultiSelectEnterpriseChange={handleMultiSelectEnterpriseChange}
                            handleMultiSelectContaminantChange={handleMultiSelectContaminantChange}
                            handleMultiSelectRiskDataGroupChange={handleMultiSelectRiskDataGroupChange}
                            handleMultiSelectActivityGroupChange={handleMultiSelectActivityGroupChange}
                            handleMultiSelectActivitySubGroupChange={handleMultiSelectActivitySubGroupChange}
                            handleMultiSelectCategoryChange={handleMultiSelectCategoryChange}></ItemCommonTop>

                        <EffluentDisposalItemSpecView itemTypes={effluentDisposal.itemTypes} itemPopupItemField={itemPopupItemField} itemPopupItemSepcQ={itemPopupItemSepcQ} handleItemSepcValueChange={handleItemSepcValueChange}
                            effluentApplicationMethodList={effluentDisposal.effluentApplicationMethodList} pondSolidsSpreadInList={effluentDisposal.pondSolidsSpreadInList}
                            seperatedSolidsStoredTypeList={effluentDisposal.seperatedSolidsStoredTypeList} seperatedSolidsSpreadInList={effluentDisposal.seperatedSolidsSpreadInList}
                            monthList={effluentDisposal.monthList} blockList={effluentDisposal.blockList} effluentStorageTypeList={effluentDisposal.effluentStorageTypeList}>
                        </EffluentDisposalItemSpecView>
                        <ItemCommonBottom itemPopup={itemPopup} itemPopupAchievements={itemPopupAchievements}
                            handleItemPopupAchievements={handleItemPopupAchievements}></ItemCommonBottom>
                    </ModalBody>

                    <ItemFooter itemPopup={itemPopup} saving={saving}
                        handleItemDeletePopup={handleItemDeletePopup}
                        handleItemSubmit={handleItemSubmit}
                        handleItemPopupClose={handleItemPopupClose}
                        handleOpenActionPopup={handleOpenActionPopup}
                        handleOpenMaintenancePlanPopup={handleOpenMaintenancePlanPopup}>
                    </ItemFooter>
                </Form>
            </Modal>
            <Modal isOpen={itemDeletePopup.showItemDeletePopup}>
                <ModalHeader toggle={handleItemDeletePopupClose} >Archive the item</ModalHeader>
                <ModalBody>
                    Do you want to archive the item ?
                </ModalBody>
                <ModalFooter>
                    {itemDeletesaving ?
                        <>
                            <Button onClick={deleteItem} color="primary" disabled>
                                <Row>
                                    <Col sm="6">
                                        <span>
                                            {' '}Saving
                                        </span>
                                    </Col>
                                    <Col sm="6">
                                        <Spinner size="sm">
                                            Saving...
                                        </Spinner>
                                    </Col>
                                </Row></Button>{' '}
                        </>
                        :
                        <>
                            <Button onClick={deleteItem} color="primary">
                                Yes
                            </Button>{' '}
                        </>
                    }
                    <Button color="danger" onClick={handleItemDeletePopupClose}>No</Button>
                </ModalFooter>
            </Modal>

            {actionPopup.showActionPopup && !actionPopup.isHavingItemBasedAction && <Action width={width} height={height} refreshItemDetails={refreshItemDetails} itemList={effluentDisposal.itemList} redirectPage="/effluentdisposal" selectedLUId={largeEnterpriseDetails.selectedLMUId}
                handleActionClose={handleActionClose} itemTypeId={actionPopup.itemTypeId} sectionName={effluentDisposal.Section} sectionId={effluentDisposal.itemTypes[0].sectionId} itemId={actionPopup.itemId} itemName={actionPopup.itemName}
                showActionPopupModal={actionPopup.showActionPopup} actionId={actionPopup.actionId} itemTypeSelect={effluentDisposal.itemTypes} itemTypeDisabled={true}></Action>}

            {actionPopup.showActionPopup && actionPopup.isHavingItemBasedAction && <ItemBasedAction width={width} height={height} refreshItemDetails={refreshItemDetails} itemList={effluentDisposal.itemList} redirectPage="/effluentdisposal" selectedLUId={largeEnterpriseDetails.selectedLMUId}
                handleActionClose={handleActionClose} itemTypeId={actionPopup.itemTypeId} sectionName={effluentDisposal.Section} sectionId={effluentDisposal.itemTypes[0].sectionId} itemId={actionPopup.itemId} itemName={actionPopup.itemName}
                showActionPopupModal={actionPopup.showActionPopup} actionId={actionPopup.actionId} itemTypeSelect={effluentDisposal.itemTypes} itemTypeDisabled={true} wholeFarmAction={false} ></ItemBasedAction>}

            {wholeFarmActionPopup.showActionPopup && <Action width={width} height={height} refreshItemDetails={refreshItemDetails} itemList={effluentDisposal.itemList} redirectPage="/effluentdisposal" selectedLUId={largeEnterpriseDetails.selectedLMUId}
                handleActionClose={handleWholeActionClose} itemTypeId={wholeFarmActionPopup.itemTypeId} sectionName={effluentDisposal.Section} sectionId={effluentDisposal.itemTypes[0].sectionId} itemId={wholeFarmActionPopup.itemId} itemName={wholeFarmActionPopup.itemName}
                showActionPopupModal={wholeFarmActionPopup.showActionPopup} actionId={wholeFarmActionPopup.actionId} itemTypeSelect={effluentDisposal.outlineItemTypes} itemTypeDisabled={true} wholeFarmAction={true}></Action>}

            {maintenancePlanPopup.showMaintenancePlanPopup && <MaintenancePlan handleMaintenancePlanClose={handleMaintenancePlanClose}
                showMaintenancePlanPopupModal={maintenancePlanPopup.showMaintenancePlanPopup}
                actionId={maintenancePlanPopup.actionId} itemId={maintenancePlanPopup.itemId} itemName={maintenancePlanPopup.itemName} itemTypeId={maintenancePlanPopup.itemTypeId}
                itemTypeSelect={effluentDisposal.itemTypes} sectionName={effluentDisposal.Section} redirectPage="/effluentdisposal">
            </MaintenancePlan>}

            {riskSummaryPopup.showriskSummary && <RiskSummary section={effluentDisposal.SectionObj} sectionId={effluentDisposal.itemTypes[0].sectionId} riskSummaryPopup={riskSummaryPopup} handleRiskSummaryClose={handleRiskSummaryClose}></RiskSummary>}
        </div>
    )
}
export default EffluentDisposal;